module.exports = __webpack_public_path__ + "static/face-8b30ed261e716b92e013f5c4cbcd24ec.jpg";